<!-- src/app/time-attendance/components/payroll-sync/pages/payroll-sync/payroll-sync.component.html -->
<app-payroll-nav></app-payroll-nav>

<div class="sync-page">
  <div
    class="toast show"
    *ngIf="toastMessage"
    [class.success]="toastKind === 'success'"
    [class.error]="toastKind === 'error'"
    [class.warning]="toastKind === 'info'"
    (click)="clearToast()"
    role="status"
    aria-live="polite"
  >
    <img
      class="icon"
      [src]="toastKind === 'success' ? '/success.png' : toastKind === 'error' ? '/fail.png' : '/warning.png'"
      alt=""
      aria-hidden="true"
    />

    <div class="toast-title">
      {{ toastKind === 'success' ? 'Success' : toastKind === 'error' ? 'Action needed' : 'Notice' }}
    </div>

    <div class="toast-body">{{ toastMessage }}</div>
  </div>

  <div class="page-header">
    <div class="title-block">
      <h2>Payroll Sync</h2>
      <p class="subtitle">
        Select a payroll week and create payable hours from booked hours.
      </p>
    </div>
  </div>

  <div *ngIf="errorMessage" class="inline-error" role="status" aria-live="polite">
    <p class="body">{{ errorMessage }}</p>
    <button type="button" class="icon-btn" (click)="errorMessage = null" aria-label="Close">×</button>
  </div>

  <div class="sync-card">
    <div class="card-head">
      <div class="head-left">
        <h3>Sync payroll week</h3>
        <div class="sub">Previous completed week is selected automatically. You can change it before syncing.</div>
      </div>

      <div class="head-right">
        <span class="pill pill-muted" *ngIf="isSyncing">Payroll sync running…</span>
      </div>
    </div>

    <div class="card-body">
      <div class="week-field">
        <label class="field-label">Payroll Week</label>

        <div class="combo">
          <div class="combo-input" (click)="openYyww()" [class.disabled]="isLoading || isSyncing">
            <span class="search-icon" aria-hidden="true">⌕</span>

            <input
              type="text"
              [value]="yywwSearch"
              (input)="onYywwSearchChange($any($event.target).value)"
              placeholder="Type year / YYWW (ex: 2026, 202620)…"
              [disabled]="isLoading || isSyncing"
              aria-label="Search payroll weeks"
            />

            <span class="combo-caret" aria-hidden="true">▾</span>
          </div>

          <div
            class="combo-panel"
            *ngIf="yywwOpen"
            role="dialog"
            aria-label="Payroll weeks"
            (click)="$event.stopPropagation()"
          >
            <div class="combo-help">
              Search updates automatically after you stop typing for <strong>1 second</strong>.
            </div>

            <div class="combo-list" (scroll)="onYywwScroll($event)" aria-live="polite" role="listbox">
              <div class="combo-empty" *ngIf="!yywwIsLoading && !yywwResults.length">
                No weeks found. Try another search.
              </div>

              <button
                type="button"
                class="combo-row"
                *ngFor="let w of yywwResults; trackBy: trackById"
                (click)="selectWeekFromDropdown(w)"
                [class.selected]="selectedYyww?.id === w.id"
                role="option"
                [attr.aria-selected]="selectedYyww?.id === w.id"
              >
                <div class="left">
                  <div class="name">
                    {{ w.fullYearWeek }}
                    <span class="selected-dot" *ngIf="selectedYyww?.id === w.id">Selected</span>
                  </div>

                  <div class="meta" *ngIf="w.startDate && w.endDate">
                    {{ w.startDate }} → {{ w.endDate }}
                  </div>
                </div>

                <div class="right">
                  <div class="tag">Week {{ w.week }}</div>
                </div>
              </button>

              <div class="combo-loading" *ngIf="yywwIsLoading">
                <div class="mini-spinner" aria-hidden="true"></div>
                <span>Loading…</span>
              </div>

              <div class="combo-end" *ngIf="!yywwIsLoading && yywwResults.length">
                <span class="muted">Scroll to load more if available.</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="summary-box">
        <span class="summary-label">Ready to sync</span>
        <span class="summary-value">{{ selectedWeekSummary }}</span>
      </div>

      <div class="actions">
        <button
          type="button"
          class="ghost-btn"
          (click)="clearSelectedWeek()"
          [disabled]="!selectedYyww || isSyncing"
        >
          Clear
        </button>

        <button
          type="button"
          class="primary-btn"
          (click)="startSync()"
          [disabled]="!canSync"
          title="Run payroll sync"
        >
          <span class="btn-inline">
            <span class="mini-spinner light" *ngIf="isSyncing" aria-hidden="true"></span>
            {{ isSyncing ? 'Syncing…' : 'Sync Payroll' }}
          </span>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading" class="busy-overlay">
    <div class="spinner"></div>
  </div>
</div>